import { Course } from "../../models/course";
import { SectionRequest } from "../../models/section";
import * as FetchUtil from "../fetch-util";

export class Courses {
  static sections(fetchAsync = false): Promise<FetchUtil.HttpResponse<FetchUtil.ErrorResponse & SectionRequest[]>> {
    return FetchUtil.get("/api/v1/sections/courses?fetchAsync=true");
  }
  static recomendations(fetchUrl: string): Promise<FetchUtil.HttpResponse<FetchUtil.ErrorResponse & Course[]>> {
    return FetchUtil.get(fetchUrl);
  }
}
